




























































import { defineComponent, ref } from '@vue/composition-api'
import VSlider from '@/components/VSlider.vue'
import { useStore } from '@/store'

export default defineComponent({
  name: 'Royerssluis',

  components: {
    VSlider
  },

  props: {
    next: String
  },

  setup() {
    const { state } = useStore()

    return {
      state
    }
  }
})
